var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12942_10274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8607 26.9456C36.5996 28.3451 37.3308 29.869 38.3666 31.0769C38.9523 31.7633 41.332 34.1936 42.0445 33.9548C42.3568 33.8824 42.7817 33.2439 42.9606 33.227C43.8143 33.1763 46.433 35.4284 47.1009 36.2062C48.0715 37.3433 47.9552 38.892 49.4161 37.412C51.3244 38.2826 52.7732 39.7997 54.0095 41.452C54.8787 42.6249 54.2857 43.3269 55.7366 41.7511C56.5563 41.6592 58.496 43.6638 59.111 44.3188C59.9868 45.257 61.3153 47.8328 61.9022 48.2613C63.002 49.0616 62.5534 47.3372 63.7056 47.7327C64.8324 49.0177 65.8612 50.3008 66.5338 51.8875C66.8366 52.6149 67.2656 55.0434 67.3674 55.1671C67.977 55.7988 69.0651 54.7612 69.5316 55.1439C70.8499 58.5688 70.8922 62.3264 68.8319 65.4793C68.5809 65.8688 68.1688 66.6148 67.6568 66.5617C66.8597 66.4888 63.3874 65.0236 62.4346 64.5941C53.3298 60.4957 47.0654 54.401 41.574 46.2251C41.4221 45.9903 41.213 45.3516 40.846 45.6085C46.1136 56.1311 55.5376 64.3402 66.5059 68.4852C65.4232 72.3318 57.8864 75.0487 54.4634 74.1121C53.528 73.8626 53.8764 72.5792 53.6369 71.8616C49.7996 72.555 45.4574 71.0706 42.5522 68.529L43.6101 67.2038C39.9928 65.4287 37.0139 62.6219 35.0109 59.1349L36.1625 57.8984C34.6806 56.2908 33.3267 54.6044 32.5638 52.5233C31.9722 50.9179 31.6166 50.0677 33.0138 48.7866C31.3445 47.7378 30.2143 41.864 31.2144 40.5523C31.4469 40.2406 31.9774 40.2158 32.0834 39.8844C32.1771 39.605 31.9707 37.8735 32.0473 37.2053C32.4388 33.5312 34.0764 30.1327 35.8607 26.9456Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12942_10274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.6819,
    height: 50.9742,
    fill: "white",
    transform: "translate(27 29) rotate(-13.0537)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMint);
export default __webpack_public_path__ + "static/media/mint.10d3edc912e8c690a3cc7932c9870810.svg";
export { ForwardRef as ReactComponent };